import * as E from 'fp-ts/lib/Either';
import {push} from 'connected-react-router';
import {all, call, put, takeEvery} from 'redux-saga/effects';
import {AsyncResult} from 'Core/models/Async';
import {getOccupation} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as AD from 'ApplicationEntry/ducks/applicantDemographics';

function* getOccupationSaga() {
  yield takeEvery(AD.ApplicantDemographicsActionType.GET_OCCUPATION, function*(
    action: ReturnType<typeof AD.getOccupation>
  ) {
    const {payload} = action;
    const {occupation} = payload;
    if (occupation !== '') {
      const response: AsyncResult<{
        occupation: {occupationCode: string; description: string; underwritingcode: string; occupationClass: string};
      }> = yield call(getOccupation, occupation);

      if (E.isRight(response)) {
        const {right} = response;

        const {description, occupationCode, underwritingcode} = right.occupation;

        yield put(AD.changeUserOccupation(occupation, occupationCode, description, underwritingcode));
      } else if (response.left.key === 'Unauthorized') {
        yield put(push(ApplicationEntryRouteConstants.AWDLogin));
      } else {
        yield put(AD.changeOccupationError(occupation));
      }
    }
  });
}

export default function*() {
  yield all([getOccupationSaga()]);
}
